"use client"

import InventoryLayout from "../../components/inventory/modules/Layout/InventoryLayout"
import { useState, useEffect } from "react"
import Card from "../../components/inventory/modules/Card/Card"
import styles from "./InventoryDashboardPage.module.css"
import TenoviTechnicalSupportSection from "../../components/inventory/TenoviTechnicalSupportSection"
import TicketRequestSection from "../../components/inventory/TicketRequestSection"
import Tabs from "../../components/inventory/modules/Tabs/Tabs"
import AddRequestModal from "../../components/inventory/modal/AddRequestModal"

const ReportsPage = () => {
  const [activeTab, setActiveTab] = useState("tenovi-support")
  const [isAddRequestModalOpen, setIsAddRequestModalOpen] = useState(false)

  // used to notify TicketRequestSection to refresh
  const [ticketRefreshTrigger, setTicketRefreshTrigger] = useState(0)

  const tabs = [
    { id: "tenovi-support", label: "Tenovi Technical Support" },
    { id: "ticket-request", label: "Ticket Request" },
  ]

  useEffect(() => {
    const savedTab = sessionStorage.getItem("inventoryActiveTab")
    if (savedTab) {
      setActiveTab(savedTab)
    }
  }, [])

  useEffect(() => {
    sessionStorage.setItem("inventoryActiveTab", activeTab)
  }, [activeTab])

  // called after AddRequestModal successfully creates a ticket
  const handleAddRequestSubmit = (serverResponse) => {
    // serverResponse is whatever createWarehouseTicket returned
    // trigger ticket list refresh in TicketRequestSection
    setTicketRefreshTrigger((t) => t + 1)
    // optional: show a quick UI feedback here (toast), handled elsewhere
    // close modal (modal also closes itself but ensure state is cleared)
    setIsAddRequestModalOpen(false)
  }

  return (
    <div className={styles.technical_support_page}>
      <div className={styles.dashboard_header}>
        <div className={styles.header_left}>
          <h1 className={styles.page_title}>Technical Support</h1>
          <p className={styles.page_subtitle}>
            Manage technical support requests and tickets
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <Card
          title="Support Overview"
          className={styles.support_card}
          headerButtons={[
            {
              label: "Add New Request",
              variant: "primary",
              onClick: () => setIsAddRequestModalOpen(true),
            },
          ]}
        >
          <div className={styles.tabs_container}>
            <Tabs
              tabs={tabs}
              activeTab={activeTab}
              onChange={setActiveTab}
              variant="secondary"
              size="medium"
            />
          </div>
          <div className={styles.tab_content}>
            {activeTab === "tenovi-support" && <TenoviTechnicalSupportSection />}
            {activeTab === "ticket-request" && <TicketRequestSection refreshTrigger={ticketRefreshTrigger} />}
          </div>
        </Card>
      </div>

      <AddRequestModal
        isOpen={isAddRequestModalOpen}
        onClose={() => setIsAddRequestModalOpen(false)}
        onSubmit={handleAddRequestSubmit}
      />
    </div>
  )
}

export default ReportsPage
